<template>
  <el-dialog :visible.sync="dialogVisible" title="查看应用升级记录" custom-class="custom-dialog" :close-on-click-modal="false"
    @opened="dialogOpen" @closed="dialogClose" width="870px">

    <el-form ref="searchForm" :inline="true" :model="searchForm">
      <el-form-item label="学校名称" prop="deptName">
        <el-input v-model="searchForm.deptName" placeholder="输入学校名称" />
      </el-form-item>
      <el-form-item label="教职姓名" prop="name">
        <el-input v-model="searchForm.name" placeholder="输入教职姓名" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="common.page=1;getTableData()">
          搜索
        </el-button>
      </el-form-item>
    </el-form>

    <el-table ref="table" v-loading="loading" :data="tableData" stripe highlight-current-row style="width: 100%">
      <el-table-column type="index" fixed label="序号" width="55px" :index="indexMethod"></el-table-column>
      <el-table-column label="学校名称" fixed prop="deptName" show-overflow-tooltip width="150px;"></el-table-column>
      <el-table-column label="应用文件名称" fixed prop="applyFileName" show-overflow-tooltip width="120px;"></el-table-column>
      <el-table-column label="教职姓名" fixed prop="name" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作系统" prop="computerSystemVersion" show-overflow-tooltip></el-table-column>
      <el-table-column label="升级前版本" prop="upgradeBeforeVersion" show-overflow-tooltip></el-table-column>
      <el-table-column label="升级后版本" prop="upgradeAfterVersion" show-overflow-tooltip></el-table-column>
      <el-table-column label="状态" show-overflow-tooltip  width="100px;">
        <template slot-scope="scope">
          <div v-if="scope.row.applyStatus == 1">正在升级</div>
          <div v-if="scope.row.applyStatus == 2">升级成功</div>
        </template>
      </el-table-column>
      <el-table-column label="升级时间" prop="gmtCreate" show-overflow-tooltip></el-table-column>
    </el-table>

    <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="common.page" :page-size="common.pageSize" :page-sizes="common.allSizes"
            layout="total,sizes, prev, pager, next, jumper" :total="common.total">
        </el-pagination>
    </div>

  </el-dialog>
</template>
<script>

import http from '../../../../../common/http'

export default {
  name: '',
  props: {
    applyManage: {
      type: Object,
      default() {
        return {}
      }
    },
    value: Boolean
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      searchForm: {
        deptName:"",
        name:""
      },
      tableData: [],
      common: {
        total: 0,            //总数据量
        pageSize: 30,        //每页条数
        page: 1,              //页码
        isPage: 1,            //是否分页
        allSizes: [30, 50, 100], //每页条数筛选
        checkboxArr: []       //多选框数组
      },
    }
  },
  watch: {
    value(val) {
      this.dialogVisible = val
    },
    dialogVisible(val) {
      this.$emit('input', val)
    }
  },
  mounted() {
  },
  methods: {
    dialogOpen() {
      this.getTableData()
    },
    indexMethod(index) {
        return (this.common.page - 1) * this.common.pageSize + (index + 1)
    },
    getTableData() {
      this.loading=true

      let url = this.thirdApplyUpgradeRecordListUrl
      let data = {
          isPage: this.common.isPage,
          page: this.common.page,
          limit: this.common.pageSize,
          applyId: this.applyManage.id,
          deptName: this.searchForm.deptName,
          name: this.searchForm.name
      };
      console.log(JSON.stringify(data))
      // return;
      this.apiPost(url, data).then((res) => {
          if (res.status == 200) {
            this.tableData = res.data.list
            this.common.total = res.data.total
          } else {
            this.$commonFn.showTip(res.message, 3)
          }
          this.loading=false
      }, (err) => {
          this.loading=false
      });
    },
    handleSizeChange(val) {
        this.common.pageSize = val;
        this.common.page = 1;
        this.getTableData();
    },
    handleCurrentChange(val) {
        this.common.page = val;
        this.getTableData();
    },
    dialogClose() {
      this.dialogVisible = false
    },

  },
  mixins: [http]
}
</script>



// WEBPACK FOOTER //
// src/components/page/apply/thirdApply/components/upgradeRecord.vue